import {
  FormStateUpdate,
  FormStates,
} from "Store/priceCalculation/priceCalculationInterfaces";

import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { insuranceNameFromUrl } from "Utils/navigation/urlUtils";
import { mapCabinContentsToForm } from "./cabinContentsMapper";
import { mapCabinToForm } from "./cabinMapper";
import { mapCaravanToForm } from "./caravanMapper";
import { mapChildToForm } from "./childMapper";
import { mapHouseContentsToForm } from "./houseContentsMapper";
import { mapHouseToForm } from "./houseMapper";
import { mapPregnantAndNewbornToForm } from "./pregnantAndNewbornMapper";
import { mapTrailerToForm } from "./trailerMapper";
import { mapTravelToForm } from "./travelMapper";

const localStorageKey = "form";

export interface LocalStorageFormValues {
  productName: INSURANCE_NAME_VALUE;
  [stepId: string]: any;
}

export function mapLocalStorageAndQueryParamsToForm(
  existingState: FormStates,
): Record<string, any> {
  const formValues = getFormValuesFromLocalStorage();
  const productName = insuranceNameFromUrl(window.location.href);
  if (productName) {
    switch (productName) {
      case INSURANCE_NAME_VALUE.CABIN:
        return mapCabinToForm(existingState, formValues);
      case INSURANCE_NAME_VALUE.CABIN_CONTENTS:
        return mapCabinContentsToForm(existingState, formValues);
      case INSURANCE_NAME_VALUE.CARAVAN:
        return mapCaravanToForm(existingState, formValues);
      case INSURANCE_NAME_VALUE.CHILD:
        return mapChildToForm(existingState, formValues);
      case INSURANCE_NAME_VALUE.HOUSE:
        return mapHouseToForm(existingState, formValues);
      case INSURANCE_NAME_VALUE.HOUSE_CONTENTS:
        return mapHouseContentsToForm(existingState, formValues);
      case INSURANCE_NAME_VALUE.PREGNANT_AND_NEWBORN:
        return mapPregnantAndNewbornToForm(existingState, formValues);
      case INSURANCE_NAME_VALUE.TRAILER:
        return mapTrailerToForm(existingState, formValues);
      case INSURANCE_NAME_VALUE.TRAVEL:
        return mapTravelToForm(existingState, formValues);
      default:
        return {};
    }
  }
  return {};
}

export function saveFormValuesToLocalStorage(formState: FormStateUpdate): void {
  if (formState.productName) {
    const newValues: LocalStorageFormValues = {
      productName: formState.productName,
      [formState.stepId]: {
        ...formState.formState,
      },
    };
    const existingValues = getFormValuesFromLocalStorage();
    localStorage.setItem(
      localStorageKey,
      JSON.stringify({
        ...existingValues,
        ...newValues,
      }),
    );
  }
}

export function deleteFormValuesFromLocalStorage(): void {
  localStorage.removeItem(localStorageKey);
}

function getFormValuesFromLocalStorage(): LocalStorageFormValues | undefined {
  const formValues = localStorage.getItem(localStorageKey);
  if (formValues) {
    return JSON.parse(formValues) as LocalStorageFormValues;
  }
  return undefined;
}
